export default __webpack_public_path__ + "slices/main/assets/public/media/company-card-1@2x.89f08830d9e477c572e3933cab951c3c.png";